import React from 'react';

import { HStack, Pressable } from '@rbilabs/universal-components';
import { useIntl } from 'react-intl';

import { Halal } from 'components/ucl/svgs/Halal';

import {
  Address,
  ServiceModes,
  Status,
  StoreCardViewContainer,
  disableColorProp,
} from '../store-card.styled';
import { StoreCardDetailsProps } from '../types';

import { StoreCardError } from './store-card-error';

export const StoreCardDetails: React.FC<StoreCardDetailsProps> = ({
  errorMessage,
  isSelected,
  storeDetails,
  onInfoPress,
}) => {
  const { formatMessage } = useIntl();
  const {
    restaurantStatus,
    serviceModesText,
    address,
    isHalal,
    distanceText,
    isActive,
  } = storeDetails;
  const storeInfo = `${distanceText} ${restaurantStatus.text}`;
  const storeCaptionAccessibility = isHalal ? formatMessage({ id: 'isHalalTitle' }) : storeInfo;
  const accessibilityLabel = `${address}, ${storeCaptionAccessibility}, ${serviceModesText}`;
  const showRestaurantStatus = (isSelected && restaurantStatus.isOpen) || !restaurantStatus.isOpen;

  return (
    <StoreCardViewContainer
      accessibilityState={{ expanded: !!isSelected }}
      accessibilityRole="togglebutton"
      accessibilityLabel={accessibilityLabel}
      accessible
      dd-action-name={`${storeDetails.address} open accordion`}
    >
      {address && (
        <HStack>
          <Pressable onPress={onInfoPress}>
            <Address {...(!isActive && disableColorProp)}>{address}</Address>
          </Pressable>
        </HStack>
      )}
      {isHalal && <Halal title={formatMessage({ id: 'isHalalTitle' })} />}
      {serviceModesText && (
        <HStack alignItems="center">
          <ServiceModes {...(!isActive && disableColorProp)}>{serviceModesText}</ServiceModes>
        </HStack>
      )}
      {showRestaurantStatus && (
        <Status
          isWithinOneHourOfClose={restaurantStatus.isWithinOneHourOfClose}
          isOpen={restaurantStatus.isOpen && isActive}
        >
          {restaurantStatus.text}
        </Status>
      )}
      {errorMessage && <StoreCardError message={errorMessage} />}
    </StoreCardViewContainer>
  );
};
